import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import metadata from './QuoteValidityComponent.metadata.json5';
import messages from './QuoteValidityComponent.messages';
import styles from './QuoteValidityComponent.module.scss';

function QuoteValidityComponent(props) {
    const {
        wizardData: submissionVM
    } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('QuoteValidityComponent');
    const translator = useTranslator();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        policyQuoteValDaysHead: {
            content: translator(messages.prQuoteValidityDays, {
                quoteValidityDays: _.get(submissionVM.value, 'baseData.quoteValidityDays_Ext') !== undefined ?
                    _.get(submissionVM.value, 'baseData.quoteValidityDays_Ext') : 0
            })
        },
        note1: {
            content: translator(messages.note1, {
                insuranceManagerNote1: _.get(submissionVM.value, 'baseData.insuranceManager') !== undefined ?
                    _.get(submissionVM.value, 'baseData.insuranceManager') : 'Premier'
            })
        },
        note2: {
            content: translator(messages.note2, {
                insuranceManagerNote2: _.get(submissionVM.value, 'baseData.insuranceManager') !== undefined ?
                    _.get(submissionVM.value, 'baseData.insuranceManager') : 'Premier'
            })
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
        },
        resolveClassNameMap: styles
    };


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

QuoteValidityComponent.propTypes = wizardProps;
export default withRouter(QuoteValidityComponent);